import api from './api';

export const invoiceService = {
  /**
   * Get invoice data for last 12 months for a project
   */
  getByProject: async (projectCode) => {
    const response = await api.get(`/invoices/${projectCode}`);
    return response.data;
  },

  /**
   * Generate or disable billing for a month
   */
  generateBilling: async (projectCode, month, enable) => {
    const response = await api.post(`/invoices/${projectCode}/generate-billing`, {
      month,
      enable,
    });
    return response.data;
  },

  /**
   * Create or remove milestone for a month
   */
  createMilestone: async (projectCode, month, enable) => {
    const response = await api.post(`/invoices/${projectCode}/create-milestone`, {
      month,
      enable,
    });
    return response.data;
  },

  /**
   * Approve milestone for a month (locks the row)
   */
  approveMilestone: async (projectCode, month, enable) => {
    const response = await api.post(`/invoices/${projectCode}/approve-milestone`, {
      month,
      enable,
    });
    return response.data;
  },

  /**
   * Delete billing for a month (only if milestone not created)
   */
  deleteBilling: async (projectCode, month) => {
    const response = await api.delete(`/invoices/${projectCode}/delete-billing`, {
      data: { month },
    });
    return response.data;
  },

  /**
   * Unlock an approved milestone (Admin only)
   */
  unlockMilestone: async (projectCode, month) => {
    const response = await api.post(`/invoices/${projectCode}/unlock-milestone`, {
      month,
    });
    return response.data;
  },

  /**
   * Get historical invoice data for a date range (Admin/SuperUser only)
   */
  getHistoricalData: async (projectCode, startMonth, endMonth) => {
    const response = await api.get(`/invoices/${projectCode}/historical`, {
      params: { startMonth, endMonth },
    });
    return response.data;
  },

  /**
   * Delete a milestone and its billing records (Admin/SuperUser only)
   */
  deleteMilestone: async (projectCode, month, forceDelete = false) => {
    const response = await api.delete(`/invoices/${projectCode}/delete-milestone`, {
      data: { month, forceDelete },
    });
    return response.data;
  },

  /**
   * Bulk delete milestones and their billing records (Admin/SuperUser only)
   */
  bulkDeleteMilestones: async (projectCode, months, forceDelete = false) => {
    const response = await api.delete(`/invoices/${projectCode}/bulk-delete-milestones`, {
      data: { months, forceDelete },
    });
    return response.data;
  },
};
